import axios from '@/api/axios'

const getCompetitiveActivity = () => {
  return axios.get('/competitive-activity-types')
}

const addCompetitiveActivity = (directory) => {
  return axios.post('/competitive-activity-type-items', null, {
    params: directory,
  })
}

const getCompetitiveActivityList = (id) => {
  return axios.get(`/competitive-activity-type-items?type_id=${id}`)
}

const getCompetitiveActivityListAll = () => {
  return axios.get(`/competitive-activity-types`)
}

const deleteCompetitiveActivityList = (id) => {
  return axios.delete(`/competitive-activity-type-items/${id}`)
}

const getCompetitiveActivityKindSport = (params) => {
  return axios.get(`/competitive-activity-types/by-kind-sport`, {params})
}

export default {
  getCompetitiveActivity,
  addCompetitiveActivity,
  getCompetitiveActivityList,
  deleteCompetitiveActivityList,
  getCompetitiveActivityListAll,
  getCompetitiveActivityKindSport,
}
